import { Component, OnDestroy, OnInit } from '@angular/core';
import ResizeObserver from 'resize-observer-polyfill';

@Component({
  selector: 'up-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'web-order-receipt';
}
